import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import Api from '../../services/ApiService';
import ClassicScreen from '../ClassicScreen';
import ModalContext from './ModalContext';

const ModalLegacy = props => {
  const [data, setData] = useState('');
  const [loading, setLoading] = useState(true);
  const { setTitle } = useContext(ModalContext);

  const { view, lookupKey, title } = props;

  const getData = () => {
    Api.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}`).then(response => {
      let data = response.data.data;
      if (Array.isArray(data)) {
        data = data.join('\n');
      }

      setData(data);
      setLoading(false);
      setTitle(`${title} (${lookupKey})`);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return <ClassicScreen>{data}</ClassicScreen>;
};

ModalLegacy.propTypes = {
  lookupKey: PropTypes.string,
  title: PropTypes.string,
  view: PropTypes.string,
};

export default ModalLegacy;
